import React, { useState, useEffect } from "react";

// mui
import { Typography, Box, ThemeProvider, Container, Skeleton, Grid } from "@mui/material";

// theme
import { restaurantThemes } from "../../themes/themes";

// components
import TopBar from "../components/TopBar";
import RestaurantCard from "../components/RestaurantCard";

// utils
import { ip, callApi } from "../../utils/api.helpers";

export default function HomePage() {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    setLoading(true);
    try {
      let url = `${ip}/api/restaurants`;
      let result = await callApi(url, "GET");

      let currentData = result.data;

      for (let i = 0; i < currentData.length; i++) {
        const element = currentData[i];
        let imageToDisplay;

        try {
          imageToDisplay = await import(`../../assets/restaurantImages/${element._id}.png`);
        } catch (e) {
          imageToDisplay = await import(`../../assets/pmdrivein.PNG`);
        }

        element.image = imageToDisplay.default;
      }

      setRestaurants(currentData || []);
    } catch (e) {
      alert(e?.response?.data?.message || e?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box sx={{ backgroundColor: "white", minHeight: "100vh" }}>
      <TopBar />

      {/* Restaurant List */}
      <Container sx={{ py: { xs: 2, sm: 3 } }}>
        {loading ? (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr", // mobile: 1 per row
                sm: "1fr 1fr", // tablet: 2 per row
                md: "1fr 1fr 1fr", // laptop: 3 per row
              },
              gap: 2,
            }}
          >
            {[1, 1, 1].map((el) => {
              return (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{
                    borderRadius: 2,
                    marginTop: "10px",
                    marginBottom: "10px",
                    boxShadow: 3,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                    },
                  }}
                />
              );
            })}
          </Box>
        ) : restaurants.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No restaurants found.
          </Typography>
        ) : (
          <Box>
            <Box sx={{ marginBottom: "16px" }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                }}
              >
                Choose Category
              </Typography>
            </Box>

            <Box sx={{ marginTop: "10px" }}>
              <Grid container spacing={2} justifyContent="center">
                {restaurants?.map((el, index) => {
                  return <RestaurantCard restaurant={el} index={index} />;
                })}
              </Grid>
            </Box>
          </Box>
        )}
      </Container>
    </Box>
  );
}
